import segment from 'util/analytics/segment'

type Action =
  | 'opened'
  | 'closed'
  | 'completed_login'
  | 'completed_sign_up'
  | 'completed_sign_up_intermediate'
  | 'completed_sign_up_final'

export interface ITrackData {
  schoolId: number
  sessionId: string
}

const events = {
  closed: 'Closed',
  completed_login: 'Completed Login',
  completed_sign_up: 'Completed Sign Up',
  completed_sign_up_final: 'Completed Sign Up Final',
  completed_sign_up_intermediate: 'Completed Sign Up Intermediate',
  opened: 'Opened',
}

export function track(action: Action, data: ITrackData) {
  segment.track(`Bookmark Auth Modal ${events[action]}`, data)
}
